import React, { Component } from 'react';
import { connect } from 'react-redux';
import { View, Text, StyleSheet } from 'react-native';
import { translate } from 'react-i18next';

import { ActionPanel, toggleRateYourWorkoutModal, UserDataConsumer } from 'fitbeat.react-native-components';

const isMobile = window.innerWidth <= 550;

class DashboardMessages extends Component {
  constructor(props) {
    super(props);
    const { user: { userProfile } } = this.props;

    this.state = {
      slides: [{
        image: '/assets/backgrounds/dontcountthedays.jpg',
        textLine1: 'Don’t count the days.',
        textLine2: 'Make the days count.',
      }, {
        image: '/assets/backgrounds/yourbodycan.jpg',
        textLine1: 'Your body can stand almost anything.',
        textLine2: 'It’s your mind that you have to convince.',
      }, {
        image: '/assets/backgrounds/makingexuses.jpg',
        textLine1: 'Losing never felt so good',
        textLine2: '',
      }, {
        image: '/assets/backgrounds/romewasntbuilt.jpg',
        textLine1: 'Fitter, healthier, happier',
        textLine2: '',
      }, {
        image: '/assets/backgrounds/romewasntbuilt.jpg',
        textLine1: 'Strong is beautiful',
        textLine2: '',
      }, {
        image: '/assets/backgrounds/thedifferencebetween.jpg',
        textLine1: 'Harder. Better. Faster. Stronger.',
        textLine2: '',
      }, {
        image: '/assets/backgrounds/thedifferencebetween.jpg',
        textLine1: 'Tough times don’t last.',
        textLine2: 'Tough people do.',
      }, {
        image: '/assets/backgrounds/makingexuses.jpg',
        textLine1: 'Every day is a choice',
        textLine2: '',
      }, {
        image: '/assets/backgrounds/yourtheonlyone.jpg',
        textLine1: 'Fitness is not a destination.',
        textLine2: 'It is a way of life.',
      }],
      activeUrlIndex: 0,
    };
  }

  componentDidMount() {
    this.swipeImage();
  }

  swipeImage = () => {
    const { slides } = this.state;
    const nextActiveIndex = Math.floor(Math.random() * (slides.length - 0) + 0);
    this.setState({
      activeUrlIndex: nextActiveIndex,
    });
  };

  render() {
    const { slides, activeUrlIndex } = this.state;
    const { canShowImage } = this.props;
    const slide = slides[activeUrlIndex];

    if (canShowImage && !isMobile) {
      return (
        <ActionPanel
          style={{ height: '100%' }}
          visible={canShowImage && !isMobile}
        >
          <View
            className='no-select'
            style={{
              position: 'relative',
              height: '100%',
            }}
          >
            <View style={styles.container}>
              <Text className='no-select' style={styles.message}>{slide.textLine1}</Text>
              <Text className='no-select' style={styles.message}>{slide.textLine2}</Text>
            </View>
            <View style={styles.imageOverlay} />
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              overflow: 'hidden',
            }}
            >
              <img
                src={slide.image}
                style={{
                  minWidth: '100%',
                  minHeight: '100%',
                  objectFit: 'cover',
                  flexShrink: 0,
                  objectPosition: 'left center',

                }}
              />
            </div>
          </View>
        </ActionPanel>
      );
    }

    return null;
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    top: '30vh',
    width: '100%',
    zIndex: 3,
  },
  message: {
    fontSize: 50,
    maxWidth: '50vw',
    fontWeight: '600',
    marginVertical: 0,
    marginHorizontal: 'auto',
    textAlign: 'center',
  },
  imageOverlay: {
    zIndex: 2,
    width: '100%',
    height: '100%',
    position: 'absolute',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },
});

const mapStateToProps = (state) => {
  const {
    toast,
    workoutPartnersModalVisible,
    plansDetailScreenVisible,
    welcomeDashboardModalVisible,
    privacySettingsModalVisible,
    mealModalVisible,
    foodPreferencesModalVisible,
    dieticianModalVisible,
    workoutHistoryModalVisible,
    privacyRemoveConfirmationModalVisible,
    workoutProgramSelectModalVisible,
    statsGraphModalVisible,
    scanReportModalVisible,
    firstVideoModalVisible,
    shoppingListEditModalVisible,
    heartRateMonitorModalVisible,
    trackingOnboardingModalVisible,
    userProfileModalVisible,
    nutritionStepsVisible,
    rateYourWorkoutModalVisible,
    weightTargetModalVisible,
    blogPostModalOpen,
    heartRateMonitorModalStudioVisible,
    bodyscanModalVisible,
    removeTargetModalVisible,
    continueOnAppScreenVisible,
  } = state.ui;

  const { isLeaderboardModalVisible } = state.summaryDashboard.view;

  const { isLeaderboardOptOutModalVisible } = state.tracking.view;

  const { paywallModalVisible } = state.payments;

  const {
    isBookingModalVisible,
  } = state.bookings.bookingWizard;

  const canShowImage = (
    !isBookingModalVisible
        && !toast
        && !workoutPartnersModalVisible
        && !plansDetailScreenVisible
        && !welcomeDashboardModalVisible
        && !privacySettingsModalVisible
        && !mealModalVisible
        && !dieticianModalVisible
        && !foodPreferencesModalVisible
        && !workoutHistoryModalVisible
        && !privacyRemoveConfirmationModalVisible
        && !workoutProgramSelectModalVisible
        && !statsGraphModalVisible
        && !scanReportModalVisible
        && !firstVideoModalVisible
        && !shoppingListEditModalVisible
        && !heartRateMonitorModalVisible
        && !trackingOnboardingModalVisible
        && !userProfileModalVisible
        && !nutritionStepsVisible
        && !rateYourWorkoutModalVisible
        && !weightTargetModalVisible
        && !paywallModalVisible
        && !isLeaderboardModalVisible
        && !isLeaderboardOptOutModalVisible
        && !blogPostModalOpen
        && !heartRateMonitorModalStudioVisible
        && !bodyscanModalVisible
        && !removeTargetModalVisible
        && !continueOnAppScreenVisible
  );

  return { canShowImage };
};

DashboardMessages = UserDataConsumer(DashboardMessages);
DashboardMessages = connect(mapStateToProps)(DashboardMessages);
export default translate(['home'], { wait: true })(DashboardMessages);
